import { Capacitor } from '@capacitor/core';
import Secrets from '@yumi/secrets';
import { getErrorDiagnostic } from './errorDiagnostics';

// Keep the fallback independent from the business clients pulled in by legacy/lib/utils.
const appVersion: string = require('../../../../package.json').version;

export interface SupportErrorDetailsProps {
  error?: unknown;
  eventId?: string;
  occurredAt?: string;
}

export const SupportErrorDetails = ({ error, eventId, occurredAt }: SupportErrorDetailsProps) => {
  const diagnostic = getErrorDiagnostic(error);
  const platform = Capacitor.getPlatform();
  const channel = platform === 'android' && Secrets.REACT_APP_PDA_SUPPORT === 'true' ? 'PDA' : platform;
  const reference = typeof eventId === 'string' && /^[a-f0-9]{32}$/i.test(eventId) ? eventId : undefined;

  return (
    <section
      aria-label='Detalle para soporte'
      style={{ width: '100%', maxWidth: '32rem', minWidth: 0, padding: '12px', boxSizing: 'border-box', border: '1px solid #d1d5db', borderRadius: '8px', textAlign: 'left', fontSize: '12px', lineHeight: 1.4, overflowWrap: 'anywhere', wordBreak: 'break-word' }}
    >
      <strong>Detalle para soporte</strong>
      <p style={{ margin: '8px 0', whiteSpace: 'pre-wrap', maxHeight: '4em', overflowY: 'auto' }}>{diagnostic.message}</p>
      {diagnostic.status && <div>HTTP: {diagnostic.status}</div>}
      {diagnostic.code && <div>Código: {diagnostic.code}</div>}
      <div>App: {appVersion} · Plataforma: {channel}</div>
      {occurredAt && <div>Fecha (UTC): {occurredAt}</div>}
      <div>{reference ? `Referencia: ${reference}` : 'Sin referencia de monitoreo'}</div>
    </section>
  );
};
